import { AxiosApi } from "./index";
import { useInfoStore } from "store/error";
import { PickListFilter } from "api/pickList";

export async function getPdfApi(guid: string) {
    const apiUri = "Pdf/Get"
    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                guid
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getSoldFrozenWeeklyReportApi(filter: PickListFilter) {
    const apiUri = "Pdf/GetSoldFrozenWeekly"
    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getSoldFrozenDailyReportApi(filter: PickListFilter) {
    const apiUri = "Pdf/GetSoldFrozenDaily"
    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getPickListReportApi(filter: PickListFilter) {
    const apiUri = "Pdf/PickListReport"
    try {
        console.log('getPickListReportApi', filter);

        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getPurchaseStatisticsReportApi(filter: PickListFilter) {
    const apiUri = "Pdf/PurchaseStatisticsReport"
    try {
        console.log('getPurchaseStatisticsReportApi', filter);

        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getSoldFreshReportApi(filter: PickListFilter) {
    const apiUri = "Pdf/GetSoldFresh"
    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

